import React, {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import CommonTooltip from '../../../../../../../../../component/common/CommonTooltip';

const OthersListTable = (props) => {

    const {
        index, 
        intent, 
        example, 
        multiple_response,
        follow_up_details
    } = props;

    let multipleResponseHtml = '';

    if( multiple_response.length > 0 ){
        multipleResponseHtml = multiple_response.map((m_response) =>
            <span className="badge badge-light-dark fs-7 fw-bold me-2 text-gray-600"  key={uuidv4()}>
                <span className="text-gray-600 fw-bold fs-6">
                    {m_response.value}
                </span>
            </span>
        )
    }

    const othersSetupDeleteOnClick = async(index) => {
        const othersSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (othersSwal.isConfirmed) {
            props.othersSetupDeleteOnClick(index)
        }
    }

    const handleDragStart = (e) => {
        e.dataTransfer.setData('text/plain', index);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'), 10);
        props.onDragDrop(draggedIndex, index);
    };

    return (
        <>
            <tr
                draggable
                onDragStart={handleDragStart}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
                style={{
                    cursor: "move",
                }}
            >
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {example}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {intent.value}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {multipleResponseHtml}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {
                        follow_up_details && follow_up_details.value
                    }
                </td>
                <td className="d-flex float-end" >
                    <div
                        className='cursor-pointer me-3' 
                        onClick={(e) => { e.preventDefault(); props.othersSetupUpdateOnClick(index);}}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Edit"
                    >
                        <FontAwesomeIcon icon={faPen} className='text-primary fs-3' />
                    </div>
                    <div
                        className='cursor-pointer'
                        onClick={(e) => { e.preventDefault(); othersSetupDeleteOnClick(index)}}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} className='text-danger fs-3' />
                    </div>
                </td>
            </tr>
            <CommonTooltip
                id="common_tooltip"
                style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                place="top"
                float={true}
            />
        </>
    )
}

const FinalSetupList = (props) => {
    const [finalFormList, setFinalFormList] = useState([]);
    useEffect(() => {
        if (props.othersFormList) {
            setFinalFormList(props.othersFormList);
        }
    }, [props.othersFormList]);
    const onDragDropHandler = (draggedIndex, targetIndex) => {
        const updatedList = [...finalFormList];
        const [draggedItem] = updatedList.splice(draggedIndex, 1);
        updatedList.splice(targetIndex, 0, draggedItem);
        updatedList.forEach((item, newIndex) => {
            item.index = newIndex;
        });
        setFinalFormList(updatedList);
        props.finalSetupOnDrop(updatedList)
    }

    let othersFormData = '';
    if( finalFormList.length > 0 ){
        othersFormData = finalFormList.map((othersData, i) =>
            <OthersListTable 
                key={i}
                index={i}
                intent={othersData.general_intent}
                example={othersData.add_example}
                multiple_response={othersData.multiple_response}
                follow_up_details={othersData.follow_up_details}
                othersSetupUpdateOnClick={props.othersSetupUpdateOnClick}
                othersSetupDeleteOnClick={props.othersSetupDeleteOnClick}
                onDragDrop={onDragDropHandler}
            />
        )
    }

    return (
        <>
            {
                finalFormList.length > 0 && 
                <>
                    <div className="separator border-gray-300 my-6"></div>
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-4">
                            <thead className="border-gray-200 fs-5 fw-semibold bg-lighten">
                                <tr className='fs-7 fw-bold border-0 text-gray-400'>
                                    <th className="">
                                        Example
                                    </th>
                                    <th className="">
                                        Intent
                                    </th>
                                    <th className="">
                                        Multiple Response
                                    </th>
                                    <th className="">
                                        Follow up Details
                                    </th>
                                    <th className=""></th>
                                </tr>
                            </thead>
                            <tbody className="fw-6 fw-semibold text-gray-600">
                                {othersFormData}
                            </tbody>
                        </table>
                    </div>
                </>
            }
        </>
    )
}

export default FinalSetupList